module.exports = __webpack_public_path__ + "media/images/icon-exit-1a243fc95eff871e9d7be179cf4cf09d.svg";